/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, string, arrayOf, func,
} from 'prop-types';
import { withRouter } from 'react-router-dom';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import withStyles from '@material-ui/core/styles/withStyles';
import PlaceIcon from '@material-ui/icons/Place';
import customBreakpoints from '../../../helpers/customBreakpoints';
import { getLanguageName } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    label: {
        display: 'block',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            margin: 'auto',
        },
        '& svg': {
            position: 'absolute',
            margin: '8px',
        },
    },
    input: {
        width: 200,
    },
    countryBlock: {
        margin: 0,
        padding: '25px 20px',
        textAlign: 'center',
        borderBottom: `1px solid ${theme.palette.colorNeutral30}`,
        borderTop: `1px solid ${theme.palette.colorNeutral30}`,
    },
    countryAutocomplete: {
        '& input': {
            width: '100%',
            border: `1px solid ${theme.palette.colorNeutral93}`,
            height: '40px',
            padding: '0 22px 0 35px',
            borderRadius: '2px',
        },
    },
    options: {
        fontSize: '15px',
        '&>span': {
            marginRight: '5px',
        },
    },
});

const CountryFinderMobile = ({
    data: {
        placeholder = '',
        country_group = [],
        text_color = '',
    }, classes, handleClose, history,
}) => {
    const onCountryChange = (e, option) => {
        e.preventDefault();
        const countryLink = option?.country?.href;
        if (countryLink && getLanguageName()) {
            history.push(`${getLanguageName()}${countryLink}`);
            handleClose();
        }
    };

    const filterOptions = createFilterOptions({
        matchFrom: 'start',
    });

    return (
        <div className={classes.countryBlock} style={{ color: text_color }}>
            <Autocomplete
                className={classes.countryAutocomplete}
                classes={{ option: classes.options }}
                id="autocomplete-input"
                data-testid="autocomplete-input"
                autoHighlight
                options={country_group?.sort((current, next) => ((current?.country?.title > next?.country?.title) ? 1 : -1))}
                getOptionLabel={(option) => option?.country?.title}
                filterOptions={filterOptions}
                onChange={(e, option) => onCountryChange(e, option)}
                renderOption={(option) => (
                    <>
                        <span>
                            <img src={option?.country_flag_image?.url} alt={option?.title} height="25" width="25" />
                        </span>
                        {option?.country?.title}
                    </>
                )}
                renderInput={(params) => (
                    <div className={classes.label} ref={params.InputProps.ref}>
                        <PlaceIcon fontSize="small" />
                        { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
                        <input className={classes.countryInput} type="text" placeholder={placeholder} variant="outlined" label={placeholder} {...params.inputProps} />
                    </div>
                )}
            />
        </div>
    );
};

CountryFinderMobile.propTypes = {
    data: shape({
        placeholder: string,
        country_group: arrayOf(shape({
            country: shape({
                title: string,
                href: string,
            }),
            country_flag_image: shape({
                url: string,
            }),
        })),
        text_color: string,
    }).isRequired,
    classes: object.isRequired,
    handleClose: func.isRequired,
    history: object.isRequired,
};

export default (withStyles(styles)(withRouter(CountryFinderMobile)));
